// extracted by mini-css-extract-plugin
export default {"mainSymbol":"mainSymbol_mainSymbol__tdhnV","circle":"mainSymbol_circle__EEk5Q"};